import { C3_LAA_COOKIE_DROP_NON_PROD, C3_LAA_COOKIE_DROP_PROD } from '../utils/constants';
import * as fetch from '../utils/fetch';

export default class CookieService {
  static callCookieDrop(concerns: string, environment: string) {
    const urlDomain = environment.toUpperCase() === 'PROD' ? C3_LAA_COOKIE_DROP_PROD : C3_LAA_COOKIE_DROP_NON_PROD;
    const url = `${urlDomain}?concerns=${concerns}`;

    return fetch.get(url, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  }
}
